// Client configuration. No secrets here: secrets live only in server environment variables.
export const config = {
  apiBase: "/api/v1/fn",
  appName: "Oxley",
  methodologyCode: "v2.1",
  motto: "Conversation proposes · Structure commits · Compiler enforces",
  /** How long an agent turn may run before the request is given up on: a little above the 340 second window the server reserves for one. */
  agentTurnTimeoutMs: 360_000,
  /** How long a save, a Keep, Remove or Undo may take before the request is given up on. Much shorter than a turn: these calls write rows and answer at once. */
  reviewTimeoutMs: 60_000,
  /** How many times a read that failed is tried again. TanStack's default, named because the app's retry rule (retryRead) repeats it. */
  readRetries: 3,
  playbookLabel: "methodology v2.1",
};
